import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	doRecoverAccountWithType,
	recoverPinCodeFailed,
	requestAccountRecoverWithType,
} from "../../../store/modules/recoverPassword/actions";
import {
	DivButtonConfirm,
	DivTimer,
	Container,
	Content,
	Title,
	Subtitle,
	MessageError,
	ButtonContainer,
	ButtonRecover,
	ContainerPinCode,
	ButtonRecoverEmail,
	TextResend,
} from "../InitialScreen/styles";
import "../../../index.scss";
import { convertSecondsInMinutes, hideCharactersEmail } from "../../../utils";
import InputPinCode from "../../../components/welcome/InputPinCode";
import whatsAppIcon from "../../../assets/WhatsApp.svg";
import smsIcon from "../../../assets/SMS.svg";
import Recaptcha from "../../../components/Recaptcha";

export default function ConfirmPinCode(props) {
	useEffect(() => {
		getRecoverType(props);
		calcIntervalResendPincode();
		// eslint-disable-next-line
	}, []);

	const dispatch = useDispatch();
	const { pinCodeFail, respAccountRecoverWithType } = useSelector((state) => state.recoverPassword);
	const [timerResend, setTimerResend] = useState("00:00");
	const [showRecaptcha, setShowRecaptcha] = useState(false);
	const [validRecaptcha, setValidRecaptcha] = useState(false);
	const [tokenRecaptcha, setTokenRecaptcha] = useState(null);
	const [resendPincodeHandler, setResendPincodeHandler] = useState(false);
	const [dataRecover] = useState(props.sendInfos);
	const [recoverSelected, setRecoverSelected] = useState("");
	const [dataRecoverFormated, setDataRecoverFormated] = useState({
		cpf: "",
		param: "",
		typeRecover: "",
		labelRecover: "",
		cellphoneEmail: "",
	});

	useEffect(() => {
		if (respAccountRecoverWithType) {
			calcIntervalResendPincode(respAccountRecoverWithType.seconds);
		}
		// eslint-disable-next-line
	}, [respAccountRecoverWithType]);

	useEffect(() => {
		if (validRecaptcha && showRecaptcha && tokenRecaptcha) {
			setShowRecaptcha(!showRecaptcha);
			setValidRecaptcha(!validRecaptcha);
			dispatch(
				requestAccountRecoverWithType(
					dataRecover.cpf,
					"CPF",
					recoverSelected,
					dataRecover.recoveryInfo,
					"",
					tokenRecaptcha
				)
			);
		}
		// eslint-disable-next-line
	}, [showRecaptcha, validRecaptcha, tokenRecaptcha]);

	function getRecoverType(props) {
		let infsRecover = props.sendInfos;

		setDataRecoverFormated({
			typeRecover: infsRecover.recoveryInfoType.includes("phone_mobile") ? "SMS" : "email",
			labelRecover: infsRecover.recoveryInfoType.includes("phone_mobile")
				? "Telefone Utilizado"
				: "E-mail utilizado",
			cellphoneEmail: infsRecover.recoveryInfoType.includes("phone_mobile")
				? maskPhone(infsRecover.recoveryInfo)
				: hideCharactersEmail(infsRecover.recoveryInfo),
		});
	}

	function maskPhone(number) {
		return `(**) ***** - ${number.substring(9, number.length)}`;
	}

	function resendPincode(recoverType) {
		setRecoverSelected(recoverType);
		setShowRecaptcha(true);
	}

	function calcIntervalResendPincode(timer = 30) {
		let controlTimer = timer;

		setTimerResend(`00:00`);
		setResendPincodeHandler(true);

		const intervaloResend = setInterval(() => {
			setTimerResend(convertSecondsInMinutes(controlTimer--));

			if (controlTimer <= 0) {
				controlTimer = 0;
				setTimerResend(controlTimer);
				setResendPincodeHandler(false);
				clearInterval(intervaloResend);
			}
		}, 1000);
	}

	function tokenConfirmation(token) {
		let pinInput = "";
		pinInput = token.toString();
		dispatch(
			doRecoverAccountWithType(
				pinInput,
				dataRecover.recoveryInfoType,
				dataRecover.recoveryInfo,
				dataRecover.cpf
			)
		);
	}

	function change() {
		dispatch(recoverPinCodeFailed(false));
	}

	return (
		<Container className="recover-pincode-container">
			<Content>
				<Title>Recuperar senha</Title>
				<Subtitle>
					Digite o código enviado por {dataRecoverFormated.typeRecover} para{" "}
					<b>{dataRecoverFormated.cellphoneEmail}</b>
				</Subtitle>
				<ContainerPinCode>
					<InputPinCode
						onSubmit={(pin) => tokenConfirmation(pin)}
						error={pinCodeFail}
						newLayout={true}
						onChangePin={change}
					/>
					{pinCodeFail ? (
						<MessageError>
							Código inválido, revise e tente novamente
						</MessageError>
					) : null}
				</ContainerPinCode>
				{!resendPincodeHandler ? (
					<ButtonContainer>
						{dataRecover.recoveryInfoType === "phone_mobile" ? (
							<TextResend>Reenviar código por:</TextResend>
						) : null}
						{dataRecoverFormated.typeRecover === "SMS" ? (
							<DivButtonConfirm>
								<ButtonRecover
									onClick={() => {
										resendPincode(
											"phone_mobile"
										);
									}}
								>
									<img
										src={smsIcon}
										alt="SMS icone"
									/>
									SMS
								</ButtonRecover>
								<ButtonRecover
									onClick={() => {
										resendPincode(
											"whatsapp"
										);
									}}
								>
									<img
										src={whatsAppIcon}
										alt="WhatsApp icone"
									/>
									WhatsApp
								</ButtonRecover>
							</DivButtonConfirm>
						) : (
							<DivButtonConfirm type={"email"}>
								<ButtonRecoverEmail
									onClick={() => {
										resendPincode(
											"email"
										);
									}}
								>
									Reenviar código
								</ButtonRecoverEmail>
							</DivButtonConfirm>
						)}
					</ButtonContainer>
				) : (
					<DivTimer>
						<span>
							Receba um novo código em{" "}
							<strong>{timerResend}</strong>
						</span>
					</DivTimer>
				)}

				{showRecaptcha && (
					<Recaptcha
						isValid={(param) => setValidRecaptcha(param)}
						token={setTokenRecaptcha}
					/>
				)}
			</Content>
		</Container>
	);
}
